// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBar_wrapper__9jNJl","title":"SearchBar_title__prIT6","container-filters":"SearchBar_container-filters__7JvrO"};